import { Container, Stack, Typography } from "@mui/material"
import { useQuery } from "@tanstack/react-query"
import React, { useMemo } from "react"
import { useParams } from "react-router-dom"

import { AgentPage } from "./AgentPage"
import { UserPage } from "./UserPage"
import { getMessageById } from "@/api/messages-api"
import { LoadingSkeletons } from "@/components/LoadingSkeletons"
import { isArweaveId } from "@/utils/arweave"

export function EntityPage() {
  const { entityId } = useParams()

  const { data: message, isFetched } = useQuery({
    queryKey: ["message", entityId],
    queryFn: () => {
      if (!entityId) throw new Error("Invalid params")

      return getMessageById(entityId)
    },
    enabled: !!entityId,
  })

  const validAddress = useMemo(() => isArweaveId(String(entityId)), [entityId])

  if (!entityId || !validAddress) {
    return (
      <Stack component="main" gap={4} paddingY={4}>
        <Typography>Invalid Entity ID.</Typography>
      </Stack>
    )
  }
  const isAgent =
    message?.tags["Simple-Agent-Type"] ||
    (message?.tags["Agent-Factory"] &&
      (message?.tags["Portfolio-Owner"] || message?.tags["Agent-Type"]))

  return (
    <Container maxWidth="lg" disableGutters>
      {!isFetched ? <LoadingSkeletons /> : isAgent ? <AgentPage /> : <UserPage />}
    </Container>
  )
}
